import React from 'react';

/**
 * Placeholder for nav destinations that have no backend endpoint yet
 * (movies/TV browse, favorites, continue watching, settings). Shows an
 * honest "coming soon" state instead of fabricating data.
 */
export function ComingSoonPage({
  title,
  description,
  icon,
}: {
  title: string;
  description: string;
  icon: React.ReactNode;
}): React.JSX.Element {
  return (
    <main className="app">
      <div className="empty-state" role="status">
        <div className="empty-state-icon" aria-hidden="true">
          {icon}
        </div>
        <h1>{title}</h1>
        <p>{description}</p>
        <span className="empty-state-tag">Скоро появится</span>
      </div>
    </main>
  );
}
